import React from 'react'
import './styles'

import { Route, Switch, Redirect } from 'react-router-dom'

import DocumentTitle from 'react-document-title'

# routes
import Summary  from './summary'
import Related  from './related'
import Emails   from './emails'
import Changes  from './changes'

# components
import UserAside  from '/components/user-aside'
import Spinner    from '/components/spinner'
import Empty      from '/components/empty'
import StateLabel from '/components/state-label'
import {
  Tabs
  TabLink
  TabContent
} from '/components/tabs'

import { withTransfer } from './queries'

export default \
withTransfer \
class Transfer extends React.Component

  render: ->
    return <Spinner/> if @props.transferLoading
    return <Empty name="Transfer" /> unless @props.transfer?.id

    transfer = @props.transfer
    # hasMany backing arrays are undefined until parsed, so don't assume
    related = (transfer.related_transfers?.length or 0) +
              (transfer.sibling_transfers?.length or 0)

    <div className="Transfer">
      <DocumentTitle title={"Transfer #{transfer.id}"}/>
      <header>
        <h1>
          Transfer to {transfer.name}
        </h1>
        <StateLabel model={transfer}/>
      </header>

      <main>

        <section className="content">
          <Tabs>
            <TabLink to={"#{@props.match.url}/summary"}>Summary</TabLink>
            <TabLink to={"#{@props.match.url}/related"}>
              Related <span className="badge">{related}</span>
            </TabLink>
            <TabLink to={"#{@props.match.url}/emails"}>Emails</TabLink>
            <TabLink to={"#{@props.match.url}/changes"}>Changes</TabLink>
            <TabContent>
              <Switch>
                <Route path='/transfers/:id/summary'  component={Summary}/>
                <Route path='/transfers/:id/related'  component={Related}/>
                <Route path='/transfers/:id/emails'   component={Emails}/>
                <Route path='/transfers/:id/changes'  component={Changes}/>
                <Redirect to={"#{@props.match.url}/summary"} />
              </Switch>
            </TabContent>
          </Tabs>
        </section>

        <UserAside id={transfer.original_cost_item?.buyer?.id}/>
      </main>

    </div>
